module.exports = __webpack_public_path__ + "static/img/0402_01.fb7e5a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0402_01.png
// module id = bqL3
// module chunks = 1